export const resultCenterDateFormat: string = 'HH:mm dd.MM';
